module.exports = __webpack_public_path__ + "static/media/kr.59dfc8e0.svg";